var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.schema.recipient)?_c('recipient',{attrs:{"model":_vm.schema.recipient}}):_vm._e(),_c('div',{staticClass:"mt-2"},[_c('w-wysiwyg',{attrs:{"model":_vm.schema.content,"config":_vm.wyswigConfig}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }